import { FaFileAlt, FaCertificate, FaBookOpen } from "react-icons/fa";
import { MdOutlineApproval, MdManageSearch } from "react-icons/md";
import { GiReceiveMoney } from "react-icons/gi";
import { Home, Store, PauseCircle, FileText, CreditCard } from "lucide-react";
import { IoDocuments } from "react-icons/io5";

const iconMap = {
  FaFileAlt,
  FaCertificate,
  FaBookOpen,
  MdOutlineApproval,
  MdManageSearch,
  Home,
  Store,
  PauseCircle,
  FileText,
  CreditCard,
  IoDocuments,
  GiReceiveMoney,
};

const mapIcon = (val) => (typeof val === "string" && iconMap[val] ? iconMap[val] : val);

const formatMenu = (menu) =>
  menu.map((item) => ({
    ...item,
    icon: mapIcon(item.icon),
    card: item.card ? { ...item.card, icon: mapIcon(item.card.icon) } : item.card,
    children: item.children
      ? item.children.map((child) => ({
          ...child,
          icon: mapIcon(child.icon),
          card: child.card ? { ...child.card, icon: mapIcon(child.card.icon) } : child.card,
        }))
      : item.children,
  }));

export default formatMenu;
